"use client";

import { preloadWorkspaceEditorCode } from "./workspace-editor-code-loader";

type WorkspacePageModule = typeof import("@/app/workspace/WorkspacePageActivation");
let pagePromise: Promise<WorkspacePageModule> | null = null;

export function loadWorkspacePageModule(): Promise<WorkspacePageModule> {
  if (!pagePromise) {
    pagePromise = import("@/app/workspace/WorkspacePageActivation").catch(error => {
      pagePromise = null;
      throw error;
    });
  }
  return pagePromise;
}

/** Общий клиентский код /page, а не RSC/документы или экземпляры страниц.
 * Импорт не монтирует компоненты: проверки доступа, настройки и запросы блоков
 * по-прежнему запускаются только настоящим переходом. Next использует те же
 * модули. Редактор загружаем параллельно, не ждём импорта оболочки.
 */
export function preloadWorkspacePageCode(): void {
  void loadWorkspacePageModule().catch(() => {
    // Необязательная подготовка не блокирует переход; Next загрузит маршрут.
  });
  preloadWorkspaceEditorCode();
}
